import {Injectable} from '@angular/core';
import {Observable, Subject} from "rxjs";
import {Notification} from "../../model/security/notification";
import {HttpClient} from '@angular/common/http';
import {ParentAPIService} from "../parent.api.service";
import {CrystalclearSecurityBackUrl} from "../config/crystalclear-security-back-url";
import {ApiValidation} from "../../model/api/api-validation";
import {ReportTask} from "../../model/archive/report-task";
import {SyncMetadata} from "../../model/api/sync-metadata";
import {RecordRequest} from "../../model/api/record-request";
import {CommonCrudService} from "../common/common-crud.service";
import {ScheduleProfile} from "../../model/tools/schedule-profile";
import {ToastService} from "../toast-service";
import {CrystalclearToolsBackUrl} from "../config/crystalclear-tools-back-url";

@Injectable({
  providedIn: 'root'
})
export class NotificationService extends CommonCrudService<Notification> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearSecurityBackUrl.GET_NOTIFICATIONS_LIST,
      CrystalclearSecurityBackUrl.SAVE_NOTIFICATION,
      CrystalclearSecurityBackUrl.DELETE_NOTIFICATION);
  }

  public notify(notification: Notification) {
    this.saveRecord(notification)
      .subscribe(response => {
      })
  }

  public createNotification(type: Notification.TYPE, state: Notification.STATE,
                            content: string, username: string,
                            taskId: string) {
    let notification = new Notification();
    notification.type = type;
    notification.state = state;
    notification.content = content;
    notification.username = username;
    notification.taskId = taskId;
    this.notify(notification);
  }

  public getIconForNotification(notification: Notification): string {
    return this.getIconForNotificationType(notification.type);
  }

  public getIconForNotificationType(notificationType: Notification.TYPE): string {
    switch (notificationType) {
      case Notification.TYPE.REPORT:
        return 'fa fa-box-archive';
      case Notification.TYPE.RECAP:
        return 'fa fa-envelope-circle-check';
      case Notification.TYPE.DOWNLOAD:
        return 'fa fa-box-archive';
      case Notification.TYPE.PREVIEW:
        return 'fa fa-box-archive';
      case Notification.TYPE.CUSTOMER:
        return 'fa fa-building-user';
      case Notification.TYPE.RELEASE:
        return 'fa fa-message';
      case Notification.TYPE.ALERT:
        return 'fa fa-triangle-exclamation';
    }
  }

  public getNotificationsSync(recordRequest: RecordRequest, username: string): Observable<ApiValidation<SyncMetadata>> {
    return this.post(CrystalclearSecurityBackUrl.POST_NOTIFICATIONS_SYNC, recordRequest, {username: username});
  }

  public getNotifications(username: string): Observable<ApiValidation<Notification[]>> {
    return this.get(CrystalclearSecurityBackUrl.GET_NOTIFICATIONS, {username: username});
  }

  // public saveNotification(notification: WebNotification): Observable<ApiValidation<WebNotification>> {
  //   return this.post(CrystalclearSecurityBackUrl.SAVE_NOTIFICATION, notification);
  // }
  //
  // public deleteNotification(notificationId: number): Observable<ApiValidation<WebNotification>> {
  //   return this.post(CrystalclearSecurityBackUrl.DELETE_NOTIFICATION, notificationId);
  // }

  public deleteAllNotification(): Observable<ApiValidation<any>> {
    return this.post(CrystalclearSecurityBackUrl.DELETE_ALL_NOTIFICATION);
  }

}
